import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck, Eye, EyeOff } from "lucide-react";
import AuthShell from "@/components/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { loginWith } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/admin/login", { email, password });
      loginWith(data.token, data.user);
      toast.success("Admin authenticated");
      navigate("/admin");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title={<span className="flex items-center gap-2"><ShieldCheck className="w-6 h-6 text-orange-500" /> Secure Admin Login</span>}
      subtitle="Authorized personnel only."
      footer={<Link to="/" className="text-gray-400 hover:text-orange-400">← Back to Home</Link>}>
      <form onSubmit={submit} className="space-y-4">
        <div><Label>Email</Label><Input data-testid="admin-email-input" type="text" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" /></div>
        <div>
          <Label>Password</Label>
          <div className="relative mt-1">
            <Input data-testid="admin-password-input" type={show ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} required />
            <button type="button" onClick={() => setShow(!show)} className="absolute end-3 top-1/2 -translate-y-1/2 text-gray-400">{show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}</button>
          </div>
        </div>
        <Button type="submit" disabled={busy} data-testid="admin-login-submit-button" className="w-full bg-orange-600 hover:bg-orange-500 btn-glow font-semibold py-6">{busy ? "..." : "Enter Admin Portal"}</Button>
      </form>
    </AuthShell>
  );
}
